import React from 'react';
import Booking from './booking';
import Header__car from './../../image/header__image.jpg';
import Logo from '../../image/stalion__logo.svg';
import './index.css';

class Header extends React.Component {
  state = {
    imageLoaded: false,
  }

  handlerOnImageLoaded = () => {
    this.setState({imageLoaded: true})
  }

  render(){
    return (
      <header className="head">
        <img className={this.state.imageLoaded ? 'head__image-loaded' : 'head__image'} src={Header__car} alt="Stalion Background Car" onLoad={this.handlerOnImageLoaded}/>
        <div className="header__logo">
            <img src={Logo} alt="Stalion"/>
        </div>
        <Booking />
      </header>
    );
  }
}

export default Header;
